// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"93ea20d5","634":"d7e79d18","5316":"93ea20d5","5387":"93ea20d5","5622":"e9066fd1","5992":"5fcc98cb","8142":"f4fd390d","8855":"1bd70320","9268":"93ea20d5","9361":"8fc1d2af"}[chunkId] + ".chunk.css";
};